import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
export interface ClubSetting {
  "@id": string;
  "@type": string;
  format: string;
  dayWeek: number;
  startEvent: string;
  startDate: string;
  endDate: string;
  openingTime: string;
  closingTime: string;
  deletable: boolean;
  id: string;
}
export const useGetSettingsQuery = clubSlug => {
  const $ = _c(2);
  let t0;
  if ($[0] !== clubSlug) {
    t0 = {
      queryKey: ["settings", clubSlug],
      queryFn: async () => {
        const response = await fetch(`/api/club-settings?clubSlug=${clubSlug}`);
        if (!response.ok) {
          throw new Error("Erreur lors de la r\xE9cup\xE9ration des param\xE8tres");
        }
        return response.json();
      }
    };
    $[0] = clubSlug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};